// JavaScript đánh số tháng từ 0, nên 7 tương ứng tháng 8.
// Thay đổi sẽ áp dụng từ ngày 01/09/2026: thay "Tỉnh Quảng Ninh" thành "Thành phố Quảng Ninh".
const QUANG_NINH_CITY_EFFECTIVE_DATE = new Date(2026, 8, 1);
// Thay đổi sẽ áp dụng từ ngày 20/09/2026: thay "Tỉnh Bắc Ninh" thành "Thành phố Bắc Ninh".
const BAC_NINH_CITY_EFFECTIVE_DATE = new Date(2026, 8, 20);

/**
 * Chuẩn hóa tên đơn vị hành chính trong địa chỉ khách hàng theo ngày hiệu lực.
 *
 * @param address Địa chỉ khách hàng nhận từ API hoặc dữ liệu đã ghép ở giao diện.
 * @param currentDate Ngày dùng để áp dụng quy tắc, mặc định là ngày hiện tại của trình duyệt.
 * @returns Địa chỉ sau khi thay thế tên tỉnh nếu đã đến ngày hiệu lực.
 */
export const normalizeCustomerAddress = (
  address: string | null | undefined,
  currentDate: Date = new Date(),
): string => {
  let normalizedAddress = address || "";

  // Chỉ chuyển tên tỉnh sau mốc hiệu lực để địa chỉ phát sinh trước đó không bị thay đổi ngoài quy tắc.
  if (currentDate >= QUANG_NINH_CITY_EFFECTIVE_DATE) {
    normalizedAddress = normalizedAddress.replace(
      /Tỉnh Quảng Ninh/g,
      "Thành phố Quảng Ninh",
    );
  }

  if (currentDate >= BAC_NINH_CITY_EFFECTIVE_DATE) {
    normalizedAddress = normalizedAddress.replace(
      /Tỉnh Bắc Ninh/g,
      "Thành phố Bắc Ninh",
    );
  }

  return normalizedAddress;
};
